var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMngStarHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#78829F",
    d: "M4.493 2.962l1.32 2.646 2.952.424-2.136 2.06L7.133 11l-2.64-1.373L1.853 11l.503-2.908L.22 6.032l2.952-.424 1.32-2.646zm0 2.23l-.658 1.319-1.47.21L3.43 7.747l-.252 1.447 1.316-.683 1.314.683-.25-1.447 1.062-1.026-1.469-.21-.657-1.318zM10.984.175l2.118 2.469c.178.208.152.52-.058.696-.21.176-.525.15-.703-.057l-1.238-1.443v6.554c0 .272-.224.493-.5.493-.275 0-.499-.22-.499-.493V1.839L8.866 3.282c-.178.207-.493.233-.703.057-.21-.177-.236-.488-.058-.696L10.223.174c.2-.232.562-.232.761 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMngStarHead);
export default __webpack_public_path__ + "static/media/mng-star-head.973a0a6ea512cac68d421d3f89fcd878.svg";
export { ForwardRef as ReactComponent };